var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TheAuthorisedAppBar',{model:{value:(_vm.menuIsOpen),callback:function ($$v) {_vm.menuIsOpen=$$v},expression:"menuIsOpen"}}),_c('TheAuthorisedMenu',{model:{value:(_vm.menuIsOpen),callback:function ($$v) {_vm.menuIsOpen=$$v},expression:"menuIsOpen"}}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }